import React, { useMemo, useCallback } from 'react';
import CreatableSelect from 'react-select/creatable';

const CreatableDropdown = ({
  options = [],
  optionValues,
  value,
  onChange,
  disabled = false,
  required = false,
  placeholder = 'Select or create...',
  className = '',
  onCreateOptionClick,
  formatCreateLabel = inputValue => `Create "${inputValue}"`,
  styles
}) => {
  // Transform options to react-select format
  const selectOptions = useMemo(() => {
    return options.map((option, index) => ({
      label: option,
      value: optionValues ? optionValues[index] : option
    }));
  }, [options, optionValues]);

  // Find current value in options
  const selectedValue = useMemo(() => {
    if (!value) return null;

    // Check if value exists in options
    const foundOption = selectOptions.find(opt => opt.value === value || opt.label === value);

    if (foundOption) return foundOption;

    // If value doesn't exist in options, it might be a newly created value
    // Return it as a new option object
    return { label: value, value: value };
  }, [value, selectOptions]);

  // Handle change event
  const handleChange = useCallback(
    (selectedOption, actionMeta) => {
      const newValue = selectedOption ? selectedOption.value : '';

      if (actionMeta.action === 'create-option' && onCreateOptionClick) {
        onCreateOptionClick(newValue, selectedOption);
        return;
      }
      if (onChange) onChange(newValue);
    },
    [onChange, onCreateOptionClick]
  );

  return (
    <CreatableSelect
      options={selectOptions}
      value={selectedValue}
      onChange={handleChange}
      isDisabled={disabled}
      isClearable={!required}
      placeholder={placeholder}
      formatCreateLabel={formatCreateLabel}
      className={className}
      classNamePrefix="creatable-select"
      menuPortalTarget={document.body}
      menuPosition="fixed"
      styles={styles}
    />
  );
};

export default CreatableDropdown;
